// useAgentUi() — main hook để component truy cập context.

import { useContext } from "solid-js";
import { AgentUiContext } from "./context";
import type { AgentUiContextValue } from "./types";

/// Assert inside <AgentUiProvider>. Throw nếu gọi ngoài provider.
export function useAgentUi(): AgentUiContextValue {
  const ctx = useContext(AgentUiContext);
  if (!ctx) {
    throw new Error(
      "useAgentUi() must be called inside <AgentUiProvider>. Wrap app inside <Router><AgentUiProvider>...</AgentUiProvider></Router>.",
    );
  }
  return ctx;
}
